import { useState } from 'react';
import { PracticeView } from '@/components/practice/PracticeView';
import { ScoreLibrary } from '@/components/library/ScoreLibrary';
import { UploadModal } from '@/components/upload/UploadModal';
import { Header } from '@/components/layout/Header';
import { useScoreStore } from '@/stores';

type View = 'library' | 'practice';

export function App() {
  const [view, setView] = useState<View>('library');
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const currentScoreId = useScoreStore((state) => state.currentScoreId);

  // Auto-switch to practice view when a score is selected
  const handleScoreSelect = (scoreId: string) => {
    useScoreStore.getState().setCurrentScore(scoreId);
    setView('practice');
  };

  return (
    <div className="h-screen bg-gray-900 text-white flex flex-col">
      <Header view={view} onViewChange={setView} onUploadClick={() => setIsUploadOpen(true)} />

      <main className="flex-1 flex flex-col min-h-0 overflow-y-auto">
        {view === 'library' ? (
          <ScoreLibrary
            onScoreSelect={handleScoreSelect}
            onUploadClick={() => setIsUploadOpen(true)}
          />
        ) : currentScoreId ? (
          <PracticeView />
        ) : (
          <div className="flex-1 flex items-center justify-center">
            <div className="text-center">
              <p className="text-gray-400 mb-4">No score selected</p>
              <button
                onClick={() => setView('library')}
                className="px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg"
              >
                Go to Library
              </button>
            </div>
          </div>
        )}
      </main>

      <UploadModal
        isOpen={isUploadOpen}
        onClose={() => setIsUploadOpen(false)}
        onSuccess={handleScoreSelect}
      />
    </div>
  );
}

export default App;
